import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  POSTHOG_KEY,
  capturePageview,
  setClusterTag,
  captureUtm,
} from "../lib/analytics";
import { getPost } from "../lib/blog";

/**
 * Drives SPA pageview capture in PostHog.
 *
 * PostHog is initialised with `capture_pageview: false`, so this component is
 * the sole source of $pageview events. Fires on initial mount and on every
 * subsequent route change. (AnalyticsScripts backfills the very first pageview
 * for visitors who accept cookies after page load.)
 *
 * cluster_tag is CONTENT-driven, never a path table. The old path table
 * (lib/clusterTag.ts, removed 2026-08-01) listed only housing-era routes and
 * silently tagged 100% of live traffic null once those routes were deleted.
 * Now the cluster comes from the post's own frontmatter (validated against
 * the five-cluster taxonomy in lib/clusterTags.ts) on /news/:slug, and null
 * everywhere else — a route change can never orphan the mapping, and a post
 * cannot ship without a (validated) cluster. Setting null also clears stale
 * values off returning visitors, since super-properties persist in
 * localStorage.
 *
 * Mounted once inside <BrowserRouter> in App.tsx. No UI.
 */
export default function ClusterTagBinder() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!POSTHOG_KEY) return;
    captureUtm();
    const slug = /^\/news\/([^/]+)\/?$/.exec(pathname)?.[1];
    setClusterTag(slug ? (getPost(slug)?.clusterTag ?? null) : null);
    capturePageview();
  }, [pathname]);

  return null;
}
